import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=739c32bf&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=739c32bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739c32bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('739c32bf')) {
      api.createRecord('739c32bf', component.options)
    } else {
      api.reload('739c32bf', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=739c32bf&scoped=true&", function () {
      api.rerender('739c32bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/labels/Index.vue"
export default component.exports